import { type FirstBoxPromoEffect } from './FirstBoxPromoEffect';
export { type FirstBoxPromoEffect };
export enum PromoType {
  FLAT_DISCOUNT,
  PERCENT_DISCOUNT,
  FREE_SHIPPING,
  // check if this exists
  FREE_ITEM,
  REFERRAL_DISCOUNT,
  FREE_ITEM_FOR_LIFE,
}

export interface PromosV2 {
  code: string;
  type: PromoType;
  value: string;
  is_expired: boolean;
  effect: string;
  threshold: number | string;
}

export interface FirstBoxPricingInfo {
  subtotal: string;
  shipping_cost: string;
  discount: string;
  potential_credit: string;
  total: string;
}

export interface CheckoutPricingInfo {
  customer_id: number;
  plan_price: string;
  plan_credits: string;
  first_box_pricing: FirstBoxPricingInfo;
  first_box_promo_effect: FirstBoxPromoEffect;
  price_per_serving: string;
  max_price_per_serving: string;
  discount_per_meal: string;
  upper_bound: string;
  lower_bound: string;
  evergreen_threshold: number;
  free_shipping_delta: string | null;
  minimum_plan_price?: string;
  meets_minimum_plan_price?: boolean;
}
